module.exports = __webpack_public_path__ + "media/images/my-location-d5f86c6c41999e432e6af73c58cb8b34.svg";